
<template>
<div class="shell-page purchase-flow-page" :class="{ 'purchase-flow-page--checkout': step > 0, 'purchase-flow-page--venue': step === 7 }">
<HeaderMain  v-show="!loadingEvent" @messageFromHeader="searchEvents"/>
<div>

</div>
<div>
       <SlideShow v-if="step===0"/>
       <SearchCourse v-if="!main" :courses="search" />

 <div :class="['purchase-flow-shell', { 'purchase-flow-shell--checkout': step > 0 }]">

    


    <section class="clean-block clean-product dark luxury-event-shell">
      
      
      <PreloaderComponent v-show="validateProc()===false"/>

      
      <div v-show="validateProc()===true" :class="['container shell-section event-view-shell', { 'event-view-shell--overview-mobile': step === 0 }]" style="padding-top: 40px; padding-bottom: 40px;">
        <div v-if="step>0" ref="checkoutStart" class="event-checkout-focus">
          <div class="event-checkout-focus__visual" :class="{ 'is-placeholder': !eventHeroImage }">
            <img v-if="eventHeroImage" :src="eventHeroImage" :alt="event.name" class="event-checkout-focus__visual-image" @load="updateEventHeroAspect" @error="shiftHeroImage">
            <div v-else class="event-checkout-focus__visual-placeholder">
              <strong>{{ event.name }}</strong>
            </div>

            <div class="event-checkout-focus__visual-overlay"></div>

            <div
              v-if="eventBrandLabel"
              class="event-view__photo-label event-view__photo-label--checkout"
              :class="`event-view__photo-label--${eventBrandLabel.key}`"
            >
              <img
                v-if="eventBrandLabel.showFomoMark"
                class="event-view__photo-label-mark"
                src="/static/FOMOPLANES_isotipo_512.png"
                alt=""
                aria-hidden="true"
              >
              <i v-else :class="eventBrandLabel.icon"></i>
              <span>{{ eventBrandLabel.label }}</span>
            </div>

            <div class="event-checkout-focus__visual-copy">
              <small>Paso {{ checkoutStage }} de 4</small>
            </div>
          </div>

          <div class="event-checkout-focus__main">
            <h2 class="event-checkout-focus__title">{{ event.name }}</h2>
            <p class="event-checkout-focus__text">{{ checkoutStepCopy }}</p>

            <div class="event-checkout-focus__micro">
              <span><i class="far fa-clock"></i>{{ formatDate(event.start_date) }}</span>
              <span><i class="fas fa-map-marker-alt"></i>{{ venue.name }}{{ city ? '. ' + city : '' }}</span>
            </div>
          </div>

          <div class="event-checkout-focus__rail">
            <div class="event-checkout-focus__steps" aria-label="Pasos de compra">
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===1, 'is-done': checkoutStage>1 }]">
                <strong>1</strong>
                <span>Accesos</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===2, 'is-done': checkoutStage>2 }]">
                <strong>2</strong>
                <span>Datos</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===3, 'is-done': checkoutStage>3 }]">
                <strong>3</strong>
                <span>Cobertura</span>
              </article>
              <article :class="['event-checkout-focus__step', { 'is-active': checkoutStage===4, 'is-done': checkoutStage>4 }]">
                <strong>4</strong>
                <span>Pago</span>
              </article>
            </div>
          </div>
        </div>

        <div
          v-if="showSeatHoldCountdown"
          :class="['event-view__hold-timer', 'container', 'cont', 'checkout-step', 'checkout-step--clean', { 'is-urgent': seatHoldCountdownUrgent }]"
          role="timer"
          aria-live="polite"
        >
          <div class="event-view__hold-timer-icon"><i class="far fa-clock"></i></div>
          <div class="event-view__hold-timer-copy">
            <small class="form-text text-muted checkout-step__eyebrow">Reserva temporal de asientos</small>
            <strong>{{ formattedSeatHoldCountdown }}</strong>
            <span class="checkout-step__hint">Completa la compra antes de que termine el tiempo.</span>
          </div>
          <div class="event-view__hold-timer-progress" aria-hidden="true">
            <span :style="{ width: `${seatHoldProgressPercent}%` }"></span>
          </div>
        </div>

        <div v-if="step===0" class="event-view-shell__overview">
        <div class="block-content luxury-panel luxury-panel--event" style="padding: 20px;">
          <div class="product-info container-fluid event-view">
            <div class="row event-view__layout">
              <div class="col-lg-6 event-view__media-column">
                <div class="gallery luxury-gallery event-view__gallery">
                  <div id="product-preview" :class="['vanilla-zoom', eventHeroFrameClass]">
                    <div v-if="eventHeroUsesSoftFill" class="event-view__gallery-soft-fill" :style="eventHeroFillStyle" aria-hidden="true"></div>
                    <img v-if="eventHeroImage" :src="eventHeroImage" class="img-fluid" :alt="event.name" @load="updateEventHeroAspect" @error="shiftHeroImage">
                    <div v-else class="premium-card__placeholder event-view__media-placeholder">
                      <div class="premium-card__placeholder-mark">{{ event.name ? event.name.slice(0, 2).toUpperCase() : 'FP' }}</div>
                      <div class="premium-card__placeholder-copy">
                        <span class="premium-card__placeholder-kicker">Evento</span>
                        <strong>{{ event.name }}</strong>
                      </div>
                    </div>
                    <div
                      v-if="eventBrandLabel"
                      class="event-view__photo-label"
                      :class="`event-view__photo-label--${eventBrandLabel.key}`"
                    >
                      <img
                        v-if="eventBrandLabel.showFomoMark"
                        class="event-view__photo-label-mark"
                        src="/static/FOMOPLANES_isotipo_512.png"
                        alt=""
                        aria-hidden="true"
                      >
                      <i v-else :class="eventBrandLabel.icon"></i>
                      <span>{{ eventBrandLabel.label }}</span>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-lg-6 event-view__content-column">
                <div class="info event-view__content">
                  <div class="event-view__eyebrow-row">
                    <span class="event-view__availability">{{ isSwapEvent ? 'FOMO SWAP' : (eventTickets.length !== 0 ? 'Disponible ahora' : 'Acceso con código') }}</span>
                  </div>

                  <h3 class="va-h4 event-view__title">{{event.name}}</h3>

                  <div ref="purchasePanel" class="event-view__purchase-box">
                    <div v-if="isSwapEvent" class="event-view__swap-copy">
                      <span class="event-view__swap-icon"><i class="fas fa-exchange-alt"></i></span>
                      <div>
                        <strong>FOMO SWAP</strong>
                        <p>{{ purchaseIntroCopy }}</p>
                        <small class="event-view__swap-trust"><i class="fas fa-shield-alt"></i> Protección 100% FOMOPLANES</small>
                      </div>
                    </div>
                    <p v-else class="event-view__purchase-text">
                      {{ purchaseIntroCopy }}
                    </p>

                    <div class="event-view__purchase-actions">
                      <div v-if="eventTickets.length!=0 || isSwapEvent" v-show="this.step==0" class="form-group event-view__cta-wrap">
                        <FomoButton @click="startSale()" variant="action" class="event-view__cta event-view__serious-button" :icon="isSwapEvent ? 'fas fa-exchange-alt' : 'fas fa-ticket-alt'">{{ eventAccessLabel }}</FomoButton>
                      </div>

                      <button v-if="showPromoToggle" class="event-view__promo-toggle" type="button" @click="openPromoCode">
                        <i class="fas fa-key"></i>
                        <span>Tengo código</span>
                      </button>

                      <div v-if="showLockedState" class="shell-empty-state event-view__locked-state">
                        Este acceso requiere invitación o código.
                      </div>

                      <div class="form-group event-view__promo-group" v-if="showPromoPanel">
                        <div class="event-view__promo-header">
                          <p class="event-view__purchase-text event-view__purchase-text--promo">
                            Si tienes código, valídalo aquí.
                          </p>
                          <button v-if="canTogglePromoVisibility" class="event-view__promo-toggle event-view__promo-toggle--inline" type="button" @click="closePromoCode">
                            <i class="fas fa-times"></i>
                            <span>Ocultar</span>
                          </button>
                        </div>

                        <div class="searchcode event-view__promo-form">
                          <label class="event-view__promo-field" for="event-promo-code">
                            <span class="event-view__promo-field-icon"><i class="fas fa-tag"></i></span>
                            <input id="event-promo-code" ref="promoInput" type="text" v-model="promoCode" class="form-control event-view__promo-input" placeholder="Código de acceso" @keyup.enter="newEventTicketsSearch()" autocapitalize="characters" spellcheck="false">
                          </label>
                          <button @click="newEventTicketsSearch()" class="event-view__promo-apply event-view__serious-button event-view__action event-view__action--secondary" type="button" :disabled="promoLoading">
                            <span class="event-view__action-glow"></span>
                            <span class="event-view__action-ring"></span>
                            <span class="event-view__action-plate"></span>
                            <span class="event-view__action-inner">
                              <span class="event-view__action-copy">{{ promoLoading ? 'Validando...' : 'Validar' }}</span>
                              <span class="event-view__action-icon"><i class="fas fa-arrow-right"></i></span>
                            </span>
                          </button>
                        </div>

                        <h6 v-if="errCode" class="blog-category blog-text-success event-view__error">{{ codeError || 'Código no encontrado o sin etapas disponibles.' }}</h6>
                      </div>
                    </div>
                  </div>

                  <SwapSellInvite v-if="isSwapEvent && step === 0" :event-id="event.id" />

                  <div class="event-view__facts">
                    <article class="event-view__fact-card event-view__fact-card--venue">
                      <span class="event-view__fact-label">Venue</span>
                      <strong class="event-view__fact-value"><i class="fas fa-map-marker-alt"></i>{{venue.name}}. {{city}}</strong>
                    </article>

                    <div class="event-view__meta-chips">
                      <article class="event-view__meta-chip event-view__meta-chip--category" :class="`is-${categorySpotlight.key}`">
                        <div class="event-view__meta-chip-art" aria-hidden="true">
                          <svg v-if="categorySpotlight.key === 'concert'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-bar event-view__category-bar--a" x="24" y="68" width="8" height="14" rx="4" />
                            <rect class="event-view__category-bar event-view__category-bar--b" x="38" y="58" width="8" height="24" rx="4" />
                            <rect class="event-view__category-bar event-view__category-bar--c" x="52" y="48" width="8" height="34" rx="4" />
                            <rect class="event-view__category-mic-head" x="72" y="36" width="18" height="28" rx="9" />
                            <path class="event-view__category-mic-stem" d="M81 64V82" />
                            <path class="event-view__category-mic-base" d="M72 82H90" />
                            <path class="event-view__category-sound" d="M92 42C98 48 100 56 98 64" />
                            <path class="event-view__category-sound event-view__category-sound--alt" d="M98 36C106 46 108 58 104 70" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'party'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__party-burst" d="M66 32L72 16" />
                            <path class="event-view__party-burst event-view__party-burst--alt" d="M78 40L94 28" />
                            <path class="event-view__party-burst event-view__party-burst--soft" d="M84 54L102 54" />
                            <path class="event-view__party-ribbon" d="M48 48C60 34 76 30 96 36" />
                            <path class="event-view__party-ribbon event-view__party-ribbon--alt" d="M44 58C58 48 72 46 90 52" />
                            <path class="event-view__party-cone" d="M34 84L54 52L84 68L54 94Z" />
                            <path class="event-view__party-cone-band" d="M50 60L70 70" />
                            <rect class="event-view__party-confetti event-view__party-confetti--square" x="82" y="18" width="8" height="8" rx="2" />
                            <circle class="event-view__party-confetti event-view__party-confetti--dot" cx="96" cy="40" r="4" />
                            <circle class="event-view__party-confetti event-view__party-confetti--small" cx="74" cy="22" r="3" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'conference'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-screen" x="28" y="24" width="64" height="28" rx="12" />
                            <path class="event-view__category-screen-line" d="M42 36H76" />
                            <path class="event-view__category-screen-line" d="M42 44H66" />
                            <path class="event-view__category-podium" d="M48 68H72L78 92H42L48 68Z" />
                            <path class="event-view__category-podium-top" d="M56 60H64" />
                            <path class="event-view__category-mic-stem" d="M60 60V68" />
                            <circle class="event-view__category-attendee" cx="30" cy="86" r="5" />
                            <circle class="event-view__category-attendee" cx="90" cy="86" r="5" />
                            <path class="event-view__category-signal" d="M66 56C72 58 76 62 78 68" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'sport'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-track" d="M22 74C30 46 52 28 80 30C90 31 98 36 104 44" />
                            <path class="event-view__category-track event-view__category-track--alt" d="M18 86C28 58 52 40 82 42C92 43 100 48 106 56" />
                            <circle class="event-view__category-ball" cx="82" cy="38" r="8" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'theatre'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-stage" d="M28 86H92" />
                            <path class="event-view__category-spot" d="M60 22L76 54H44L60 22Z" />
                            <path class="event-view__category-curtain" d="M34 34C42 40 44 52 42 70C36 66 32 56 34 34Z" />
                            <path class="event-view__category-curtain" d="M86 34C78 40 76 52 78 70C84 66 88 56 86 34Z" />
                            <path class="event-view__category-curtain-line" d="M48 34V78" />
                            <path class="event-view__category-curtain-line" d="M72 34V78" />
                            <path class="event-view__category-arch event-view__category-arch--inner" d="M42 86C42 66 50 52 60 52C70 52 78 66 78 86" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'cinema'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <rect class="event-view__category-frame" x="28" y="34" width="64" height="44" rx="10" />
                            <path class="event-view__category-play" d="M54 46L74 56L54 66V46Z" />
                            <circle class="event-view__category-reel" cx="42" cy="34" r="6" />
                            <circle class="event-view__category-reel" cx="78" cy="34" r="6" />
                            <path class="event-view__category-perf" d="M36 42V70" />
                            <path class="event-view__category-perf" d="M84 42V70" />
                            <path class="event-view__category-screen-line" d="M44 86H76" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'culture'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-arch" d="M34 82C34 62 46 44 60 44C74 44 86 62 86 82" />
                            <path class="event-view__category-arch event-view__category-arch--inner" d="M44 82C44 68 52 56 60 56C68 56 76 68 76 82" />
                            <path class="event-view__category-beam" d="M60 30V88" />
                          </svg>

                          <svg v-else-if="categorySpotlight.key === 'food'" class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-cutlery" d="M44 24V54" />
                            <path class="event-view__category-cutlery" d="M38 24V40" />
                            <path class="event-view__category-cutlery" d="M50 24V40" />
                            <path class="event-view__category-cutlery event-view__category-cutlery--knife" d="M74 24V54" />
                            <circle class="event-view__category-plate" cx="60" cy="66" r="24" />
                            <circle class="event-view__category-plate event-view__category-plate--inner" cx="60" cy="66" r="12" />
                          </svg>

                          <svg v-else class="event-view__category-svg" viewBox="0 0 120 120" fill="none">
                            <path class="event-view__category-drift" d="M28 66C38 48 52 40 70 42C82 44 92 50 98 60" />
                            <path class="event-view__category-drift event-view__category-drift--alt" d="M24 78C38 62 52 56 70 58C84 60 94 66 100 76" />
                            <circle class="event-view__category-core" cx="60" cy="60" r="10" />
                          </svg>
                        </div>

                        <div class="event-view__meta-chip-copy">
                          <span class="event-view__meta-chip-label">Categoría</span>
                          <strong class="event-view__meta-chip-value"><i :class="category.icon"></i>{{category.name}}</strong>
                        </div>
                      </article>

                      <article class="event-view__meta-chip event-view__meta-chip--date">
                        <div class="event-view__meta-chip-copy">
                          <span class="event-view__meta-chip-label">Fecha</span>
                          <strong class="event-view__meta-chip-value"><i class="far fa-clock"></i>{{formatDate(event.start_date)}}<span v-if="event.show_end_date==true"> - {{formatDate(event.end_date)}}</span></strong>
                        </div>
                      </article>
                    </div>
                  </div>

                  <div class="ftr" v-if="event.id==1">
                    <div class="alert alert-primary event-view__club-note" role="alert">
                      <strong class="event-view__star">★</strong> <strong>FOMOCLUB</strong> - Este evento cuenta con FOMOPLANES y sus socios para la producción y organización de la experiencia.
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row event-view__overview-story">
              <div class="col-12">
                <div class="summary luxury-summary event-view__description-panel" ref="anchor1" id="anchor1">
                  <div class="event-view__description-header">
                    <span class="event-view__description-kicker">Descripción</span>
                  </div>

                  <div class="event-view__description-body">
                    <p v-for="(paragraph, index) in eventDescriptionParagraphs" :key="`event-description-${index}`" class="event-view__description">
                      {{ paragraph }}
                    </p>

                    <p v-if="!eventDescriptionParagraphs.length" class="event-view__description event-view__description--empty">
                      Este evento todavía no tiene descripción publicada.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <Teleport to="body">
          <div v-if="step === 0" class="event-view__mobile-assist" aria-live="polite">
            <div class="event-view__mobile-assist-card">
              <div class="event-view__mobile-assist-copy">
                <span>{{ mobileAssistKicker }}</span>
                <strong>{{ mobileAssistHeadline }}</strong>
                <small>{{ mobileAssistText }}</small>
              </div>

              <div class="event-view__mobile-assist-actions">
                <button @click="handleMobileAssistPrimary()" class="event-view__mobile-assist-primary" type="button">
                  <i :class="mobileAssistPrimaryIcon"></i>
                  <span>{{ mobileAssistPrimaryLabel }}</span>
                </button>

                <button v-if="mobileAssistHasSecondary" @click="focusPromoCode()" class="event-view__mobile-assist-secondary" type="button" aria-label="Ir a código de acceso">
                  <i class="fas fa-key"></i>
                </button>
              </div>
            </div>
          </div>
        </Teleport>

                    

                    <section >
                   
                    <div  id="detailpre" v-if="step==0 && !isSwapEvent" class="product-info" style="padding-top: 20px;">
                         <EventViewDetail :updatesProp="updates" :eventTickets="eventTickets" :eventType="event.access"/>  
                    </div>

                    <div v-if="step==1" class="product-info" style="padding-top: 20px;">
                        
                         <SwapMarketplace v-if="isSwapEvent" ref="swapMarketplace" :event="event" @quote-held="handleSwapQuoteHeld" />
                         <SaleQuantity v-else @messageFromCart="startUserCreation" :eventTickets="eventTickets" :coordinated_fee="event.coordinated_fee" :coordinated_service="event.coordinated_service" :fixed_fee="event.fixed_fee" :paymentOptions="event.payment_options || []" :presentmentCurrency="event.presentment_currency || 'USD'"/>  

                    </div>

                    <div v-if="step==7" class="product-info event-view__dynamic-venue-step" style="padding-top: 20px;">
                         <DynamicVenueMap :key="event.id + '-' + code + '-' + ($route.query.stage || '')" :event="event" :code="code || ''" :stage-id="normalizeStageQueryValue($route.query.stage)" @messageFromDynamicVenue="startDynamicVenueSale" @fallback="startNormalCheckoutFallback" />
                    </div>




                    <template v-if="step==5">
  <VaButton style="margin: 20px;" @click="showModal = !showModal">
    Abrir mapa
  </VaButton>

  <VaModal
    v-model="showModal"
    overlay-opacity="0.2"
    no-outside-dismiss
    fullscreen
    backgroundColor	="rgb(10,2,49)"

    

  >

  <h3 class="va-h3">
      Selección de Asientos
    </h3>


  <div v-for="(product, index)  in seatsProducts" :key="index ">
                          <VenueMap  @messagefromVenueMap="startUserCreation1" v-if="index==mapValidator" :id="product.id" :quantityM="product.quantity_factor*product.quantity"/>  
                        </div>
  </VaModal>
</template>
                       
      


                  

                     <div v-if="step==2 " class="product-info" style="padding-top: 20px;">
                      <GuestNameBar v-if="event.access==5" @messageFromGuestName="startFinalSale" :event="event" :productsProp="products" :order_finalF="order_total" :selectedSeats="selectedSeats" :seatsProducts="seatsProducts"/>  
                         
                      <GuestName v-if="event.access!=5" @messageFromGuestName="startFinalSale" :event="event" :productsProp="products" :order_finalF="order_total" :selectedSeats="selectedSeats" :seatsProducts="seatsProducts"/>  
                         
                     </div>


                     <div v-if="step==6" class="product-info" style="padding-top: 20px;">
                           <FomoSafeStep
                             @messageFromAddons="startPaymentStep"
                             :ticketsTable="ticketsTable"
                             :subtotal="order_subtotal"
                             :fee="order_fee"
                             :total="order_base_total"
                             :presentmentCurrency="event.presentment_currency || 'USD'"
                             :fomoSafePricing="event.fomo_safe_pricing || null"
                           />
                     </div>


                     <div v-if="step==3" class="product-info" style="padding-top: 20px;">
                           <CustomerData @messageFromCustomerData="completeSale" @holdExpired="handleHoldExpirationFailure" :ticketsTable="ticketsTable" :totalProp="order_total" :subtotalProp="order_subtotal" :feeProp="order_fee" :taxesProp="order_taxes" :addonsTotalProp="order_addons_total" :addonsProp="selectedAddons" :posProp="event.pos" :customer_prop="customer"  :event="event" :paymentOptionsProp="event.payment_options || []" :code="code"/>
                     </div>

                    <div v-if="step==4 && saleResult==1" class="product-info" style="padding-top: 20px;">
                      <p>Fomo plan activado. Tus accesos han sido enviados al correo registrado y puedes obtenerlos desde la opción <strong>Mis Planes</strong></p>
                    </div>

                    <div v-if="step==4 && saleResult==2" class="product-info" style="padding-top: 20px;">
                      <p>Fomo plan activado. Tus accesos han sido enviados al correo registrado y puedes obtenerlos desde la opción <strong>Mis Planes</strong></p>
                    </div>

                  </section>              
                    
                    <div class="clean-related-items"></div>
      </div>
  </section>




 </div>

    <footer v-show="!loadingEvent">
        <FooterMain/>
    </footer>

    <Teleport to="body">
      <Transition name="hold-expiry" @after-leave="focusExpiredHoldMap">
        <div v-if="holdExpiryDialogVisible" class="event-view__hold-expiry-overlay purchase-flow-page--checkout" role="dialog" aria-modal="true" aria-labelledby="hold-expiry-title">
          <section class="event-view__hold-expiry-card container cont checkout-step checkout-step--clean">
            <div class="checkout-step__intro">
              <small class="form-text text-muted checkout-step__eyebrow event-view__hold-expiry-kicker">Reserva vencida</small>
              <h2 id="hold-expiry-title" class="text-justify va-h6 checkout-step__title"><strong>Volvimos al mapa para proteger tu compra.</strong></h2>
              <p class="checkout-step__hint">El tiempo de reserva terminó y esos asientos se liberaron. Selecciona lugares disponibles nuevamente para continuar.</p>
            </div>
            <div class="event-view__hold-expiry-warning checkout-guest-card">
              <strong>¿Ya hiciste la transferencia?</strong>
              <span>No transfieras otra vez. Conserva el comprobante; el correo de aviso incluye los pasos para que FOMO revise tu pago.</span>
            </div>
            <Transition name="hold-expiry-email" mode="out-in">
              <p :key="holdExpiryEmailState" class="event-view__hold-expiry-email-state">{{ holdExpiryEmailMessage }}</p>
            </Transition>
            <button
              class="event-view__hold-expiry-action checkout-step__button liquid-page-button"
              type="button"
              :disabled="holdExpiryHandling"
              @click="acknowledgeHoldExpiration"
            >
              <span class="liquid-page-button__glow"></span>
              <span class="liquid-page-button__ring"></span>
              <span class="liquid-page-button__inner">
                <span class="liquid-page-button__copy">{{ holdExpiryHandling ? 'Volviendo al mapa...' : 'Elegir nuevos asientos' }}</span>
                <span class="liquid-page-button__icon"><i class="fas fa-arrow-right"></i></span>
              </span>
            </button>
          </section>
        </div>
      </Transition>
    </Teleport>


</div>
</div>

</template>

<script>
import FomoButton from '@/components/ui/FomoButton.vue'
// @ is an alias to /src
import { apiService, apiServiceSession } from "../common/api.services.js";

import HeaderMain from "@/components/HeaderMain.vue"
import FooterMain from "@/components/FooterMain.vue";
import EventViewDetail from "@/components/EventViewDetail.vue";
import SlideShow from "@/components/SlideShow.vue";
import SearchCourse from "@/components/SearchCourse.vue";
import baguetteBox from "../../node_modules/baguettebox.js"
import SaleQuantity from "@/components/sales/SaleQuantity.vue"
import CustomerData from "@/components/sales/CustomerData.vue"
import GuestName from "@/components/sales/GuestName.vue"
import GuestNameBar from "@/components/sales/GuestNameBar.vue"
import FomoSafeStep from "@/components/sales/FomoSafeStep.vue"
import VenueMap from "@/components/sales/VenueMap.vue"
import DynamicVenueMap from "@/components/sales/DynamicVenueMap.vue"
import SwapMarketplace from "@/components/sales/SwapMarketplace.vue"
import SwapSellInvite from "@/components/swap/SwapSellInvite.vue"
import PreloaderComponent from "@/components/PreloaderComponent.vue"
import { isSquareBanner } from '@/common/banner-image.js'
import { formatEventDate } from '@/common/event-timezone.js'

const EVENT_VIEW_REQUEST_TIMEOUT_MS = 30000


export default {
  name: "EventView",

   props: {

    slug: {
      required: true
    },
    

    //log25
    
  },

 


  data(){
    return{
      search:[],
      searchField:"",
      main: true,
      err: false,
      requestUserStatus: false,
      requestUserType: false,
      showLoading: false,
      event: {},
      venue: {},
      category: {},
      city: "",
      eventTickets: [],
      defaultEventTickets: [],
      updates: [],
      host: null,
      code: null,
      next: null,
      errCode: false,
      promoCode: "",
      saleMode: false,
      order_fee: 0,
      order_taxes: 0,
      order_addons_total: 0,
      order_base_total: 0,
      order_total:0,
      products: [],
      step: 0,
      name: "",
      last_name: "",
      phone: "",
      email: "",
      cc: "",
      ticketsTable: [],
      order_subtotal: 0,
      wanted: false,
      saleResult: 0,
      auto_sale: false,
      id: null,
      main_fn:"",
      main_ln:"",
      main_ph:"",
      customer: {},
      selectedAddons: [],
      map: false,
      selectedSeats: [],
      seatsProducts: [],
      mapValidator: 0,
      mapLenght: 0,
      showCode: false,
      promoLoading: false,
      loadingEvent: false,
      showModal: true,
      pixelId: null,
      scriptLoaded: false,
      eventImageIndex: 0,
      eventHeroAspect: 'unknown',
      ticketRequestVersion: 0,
      suppressPromoRouteWatcher: false,
      codeError: '',
      previewMode: false,
      swapCart: null,
      seatHoldTimer: null,
      seatHoldSecondsRemaining: 0,
      seatHoldInitialSeconds: 0,
      holdExpiryDialogVisible: false,
      holdExpiryHandling: false,
      holdExpiryEmailState: 'pending',

      

    };
  },
  components: {
    FomoButton,
    HeaderMain,
    FooterMain,
    SlideShow,
    SearchCourse,
    EventViewDetail,
    SaleQuantity,
    CustomerData,
    GuestName,
    FomoSafeStep,
    VenueMap,
    DynamicVenueMap,
    SwapMarketplace,
    SwapSellInvite,
    PreloaderComponent,
    GuestNameBar
  

  },

  computed: {
    eventImageCandidates() {
      return [this.event.banner_url, this.event.image_url, this.event.cover_url, this.event.thumbnail]
        .filter(Boolean)
        .flatMap((value) => this.resolveMediaCandidates(value))
    },

    eventHeroImage() {
      return this.eventImageCandidates[this.eventImageIndex] || ''
    },

    eventHeroFrameClass() {
      return {
        'is-square': this.eventHeroAspect === 'square',
        'is-portrait': this.eventHeroAspect === 'portrait',
        'is-landscape': this.eventHeroAspect === 'landscape',
        'has-soft-fill': this.eventHeroUsesSoftFill,
      }
    },

    eventHeroUsesSoftFill() {
      return this.eventHeroAspect === 'soft-fill'
        || this.eventHeroAspect === 'portrait'
        || this.eventHeroAspect === 'landscape'
    },

    eventHeroFillStyle() {
      if (!this.eventHeroUsesSoftFill || !this.eventHeroImage) {
        return null
      }

      return {
        backgroundImage: `url("${this.eventHeroImage}")`,
      }
    },

    eventDescriptionParagraphs() {
      return String(this.event.description || '')
        .split(/\n+/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean)
    },

    categorySpotlight() {
      const category = this.category || {}
      const source = `${category.name || ''} ${category.icon || ''}`.toLowerCase()

      if (/(concert|concierto|recital|live|show|band|banda)/.test(source)) {
        return {
          key: 'concert',
          label: 'Concierto',
        }
      }

      if (/(party|fiesta|club|dj|rave|night|after|festival)/.test(source)) {
        return {
          key: 'party',
          label: 'Fiesta',
        }
      }

      if (/(conference|conferencia|summit|forum|expo|congreso|business|network|tech|startup)/.test(source)) {
        return {
          key: 'conference',
          label: 'Conferencia',
        }
      }

      if (/(sport|deport|futbol|football|run|running|tenis|tennis|golf|padel|fitness|match)/.test(source)) {
        return {
          key: 'sport',
          label: 'Deporte',
        }
      }

      if (/(theatre|teatro|obra|musical|drama|stage)/.test(source)) {
        return {
          key: 'theatre',
          label: 'Teatro',
        }
      }

      if (/(cine|film|cinema|movie|pelicula|screening)/.test(source)) {
        return {
          key: 'cinema',
          label: 'Cine',
        }
      }

      if (/(art|arte|cultur|gallery|galeria|museum|museo)/.test(source)) {
        return {
          key: 'culture',
          label: 'Cultura',
        }
      }

      if (/(food|drink|gastro|brunch|dinner|wine|cocktail|chef|restaurant|restaurante)/.test(source)) {
        return {
          key: 'food',
          label: 'Gastronomia',
        }
      }

      return {
        key: 'default',
        label: 'Evento',
      }
    },

    checkoutStage() {
      if (this.step === 3) {
        return 4
      }

      if (this.step === 6) {
        return 3
      }

      if (this.step === 2 || this.step === 5) {
        return 2
      }

      if (this.step >= 1) {
        return 1
      }

      return 0
    },

    isSwapEvent() {
      return this.event && this.event.event_type === 'external' && this.event.commerce_mode === 'swap'
    },

    eventBrandLabel() {
      if (this.isSwapEvent) {
        return { key: 'swap', label: 'SWAP', icon: 'fas fa-exchange-alt' }
      }

      if (this.event && this.event.is_fomo_original) {
        return { key: 'fomo-original', label: 'ORIGINAL', showFomoMark: true }
      }

      return null
    },

    checkoutStepCopy() {
      if (this.isSwapEvent && this.step === 1) {
        return 'Compra entradas de asistentes que están vendiendo o intercambiando sus entradas. FOMOPLANES protege tu compra al 100%.'
      }

      if (this.step === 7) {
        return 'Elige tus entradas en el mapa. Puedes combinar opciones y secciones antes de continuar.'
      }

      if (this.step === 1) {
        return 'Elige tus accesos y revisa el subtotal antes de continuar con los datos del comprador.'
      }

      if (this.step === 2 || this.step === 5) {
        return 'Completa datos en un entorno limpio, suave y rápido para no romper el deseo de compra.'
      }

      if (this.step === 6) {
        return 'Activa en segundos una capa adicional para proteger el valor elegible de tu compra ante imprevistos personales validables.'
      }

      if (this.step === 3) {
        return 'Cierra con un total impecable, métodos claros y una última sensación premium antes del acceso.'
      }

      return 'Compra activa y lista para avanzar.'
    },

    checkoutStageLabel() {
      if (this.checkoutStage === 1) {
        return 'Selección de accesos'
      }

      if (this.checkoutStage === 2) {
        return 'Datos del comprador'
      }

      if (this.checkoutStage === 3) {
        return 'Cobertura FOMO'
      }

      if (this.checkoutStage === 4) {
        return 'Pago y cierre'
      }

      return 'Compra activa'
    },

    checkoutAvailabilityLabel() {
      if (this.event.access === 1 && this.eventTickets.length !== 0) {
        return 'Compra abierta'
      }

      if (this.event.access === 1) {
        return 'Venta en preparación'
      }

      return 'Acceso con código'
    },

    dynamicVenueAvailable() {
      return Boolean(this.event && this.event.checkout_view !== 'categories' && this.event.dynamic_venue_enabled && this.event.dynamic_venue_status === 'published')
    },

    seatHoldDeadline() {
      const deadlines = this.selectedSeats
        .filter((seat) => seat && seat.hold_token)
        .map((seat) => Date.parse(seat.hold_expires_at || ''))
        .filter((deadline) => Number.isFinite(deadline))
      return deadlines.length ? Math.min(...deadlines) : 0
    },

    showSeatHoldCountdown() {
      return this.step > 0 && this.step !== 7 && this.seatHoldDeadline > 0 && this.seatHoldSecondsRemaining > 0
    },

    formattedSeatHoldCountdown() {
      const totalSeconds = Math.max(0, this.seatHoldSecondsRemaining)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },

    seatHoldCountdownUrgent() {
      return this.seatHoldSecondsRemaining > 0 && this.seatHoldSecondsRemaining <= 120
    },

    seatHoldProgressPercent() {
      if (this.seatHoldInitialSeconds <= 0) return 0
      return Math.max(0, Math.min(100, (this.seatHoldSecondsRemaining / this.seatHoldInitialSeconds) * 100))
    },

    holdExpiryEmailMessage() {
      if (this.holdExpiryEmailState === 'sent') {
        return 'Enviamos un correo al comprador explicando por qué venció la reserva.'
      }
      if (this.holdExpiryEmailState === 'unavailable') {
        return 'Todavía no teníamos un correo confirmado para enviar el aviso.'
      }
      if (this.holdExpiryEmailState === 'failed') {
        return 'No pudimos confirmar el envío del correo. Conserva el comprobante y contacta a FOMO.'
      }
      return 'Estamos preparando el aviso por correo.'
    },

    eventAccessLabel() {
      const customLabel = typeof this.event.public_cta_label === 'string' ? this.event.public_cta_label.trim() : ''

      if (this.isSwapEvent) {
        return customLabel && customLabel !== 'Comprar reventa' ? customLabel : 'Comprar entradas'
      }

      if (customLabel) {
        return customLabel
      }

      if (Number(this.event.access) === 6) {
        return 'Aplicar a Grupo'
      }

      return 'Comprar ahora'
    },

    purchaseIntroCopy() {
      if (this.isSwapEvent) {
        return 'Compra entradas de asistentes que están vendiendo o intercambiando sus entradas. FOMOPLANES protege tu compra al 100%.'
      }

      if (this.event.access === 1) {
        return 'Compra activa ahora. Si tienes código, puedes validarlo.'
      }

      return 'Acceso reservado con invitación o código.'
    },

    hasResolvedPromoAccess() {
      if (this.errCode || this.promoLoading || this.eventTickets.length === 0) {
        return false
      }

      const requestedStage = this.normalizeStageQueryValue(this.$route.query.stage)
      const resolvedCode = this.normalizePromoCodeValue(this.code || this.$route.query.co)

      return Boolean(requestedStage || resolvedCode)
    },

    canTogglePromoVisibility() {
      return this.step === 0 && this.event.access === 1
    },

    showPromoToggle() {
      if (this.isSwapEvent) {
        return false
      }

      return this.canTogglePromoVisibility && !this.showPromoPanel && !this.hasResolvedPromoAccess
    },

    showLockedState() {
      if (this.isSwapEvent) {
        return false
      }

      return this.step === 0 && this.event.access !== 1 && this.eventTickets.length === 0
    },

    showPromoPanel() {
      if (this.isSwapEvent) {
        return false
      }

      if (this.step !== 0) {
        return false
      }

      if (this.errCode || this.promoLoading) {
        return true
      }

      if (this.hasResolvedPromoAccess) {
        return false
      }

      if (this.event.access !== 1) {
        return true
      }

      return this.showCode
    },

    mobileAssistKicker() {
      if (this.isSwapEvent) {
        return 'FOMO Swap'
      }

      return this.eventTickets.length !== 0 ? 'Compra rapida' : 'Acceso guiado'
    },

    mobileAssistHeadline() {
      if (this.isSwapEvent) {
        return 'Compra Swap protegida'
      }

      return this.eventTickets.length !== 0 ? 'No pierdas la compra' : 'Valida tu código'
    },

    mobileAssistText() {
      if (this.isSwapEvent) {
        return 'Compra entradas de asistentes; FOMO protege la reserva y la entrega.'
      }

      return this.eventTickets.length !== 0
        ? 'Te llevo directo a seleccionar accesos.'
        : 'Abro el campo para validar tu código.'
    },

    mobileAssistPrimaryLabel() {
      if (this.isSwapEvent) {
        return 'Ver localidades'
      }

      return this.eventTickets.length !== 0 ? this.eventAccessLabel : 'Validar código'
    },

    mobileAssistPrimaryIcon() {
      if (this.isSwapEvent) {
        return 'fas fa-right-left'
      }

      return this.eventTickets.length !== 0 ? 'fas fa-ticket-alt' : 'fas fa-key'
    },

    mobileAssistHasSecondary() {
      if (this.isSwapEvent) {
        return false
      }

      return this.showLockedState
    },
  },

  watch: {
    step(newStep, oldStep) {
      if (newStep === oldStep || newStep === 0) {
        return
      }

      this.$nextTick(() => {
        const checkoutTarget = this.$refs['checkoutStart'] || this.$refs['anchor1']

        if (checkoutTarget && checkoutTarget.scrollIntoView) {
          checkoutTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },

    '$route.query.co'(nextCode, previousCode) {
      if (nextCode === previousCode || !this.id) {
        return
      }

      if (this.suppressPromoRouteWatcher) {
        this.suppressPromoRouteWatcher = false
        return
      }

      this.getEventTickets()
    },

    '$route.query.stage'(nextStage, previousStage) {
      if (nextStage === previousStage || !this.id) {
        return
      }

      this.getEventTickets()
    },

    '$route.params.slug'(nextSlug, previousSlug) {
      if (nextSlug === previousSlug) {
        return
      }

      this.getEvent()
    },

    '$route.query.preview'(nextPreview, previousPreview) {
      if (nextPreview === previousPreview) {
        return
      }

      this.getEvent()
    },

    eventHeroImage() {
      this.eventHeroAspect = 'unknown'
    },
  },

  mounted() {
    //require('../assets/js/theme.js')
// Custom theme code


var vanillaZoom = {};
        vanillaZoom.init = function(el) {

            var container = document.querySelector(el);
            if(!container) {
                return;
            }

            var firstSmallImage = container.querySelector('.small-preview');
            var zoomedImage = container.querySelector('.zoomed-image');

            if(!zoomedImage) {
                return;
            }

            if(!firstSmallImage) {
                return;
            }
            else {
                // Set the source of the zoomed image.
                zoomedImage.style.backgroundImage = 'url('+ firstSmallImage.src +')';
                firstSmallImage.classList.add('active');
            }   

            // Change the selected image to be zoomed when clicking on the previews.
            container.addEventListener("click", function (event) {
                var elem = event.target;

                if (elem.classList.contains("small-preview")) {
                    
                    var allSmallPreviews = container.querySelectorAll(".small-preview");
                    
                    allSmallPreviews.forEach(function (preview) {
                        preview.classList.remove('active');
                    })
                    
                    elem.classList.add('active');
                    
                    var imageSrc = elem.src;
                    zoomedImage.style.backgroundImage = 'url('+ imageSrc +')';
                }
            });
            
            // Zoom image on mouse enter.
            zoomedImage.addEventListener('mouseenter', function() {
                this.style.backgroundSize = "250%"; 
            }, false);


            // Show different parts of image depending on cursor position.
            zoomedImage.addEventListener('mousemove', function(e) {
                
                // getBoundingClientReact gives us various information about the position of the element.
                var dimentions = this.getBoundingClientRect();

                // Calculate the position of the cursor inside the element (in pixels).
                var x = e.clientX - dimentions.left;
                var y = e.clientY - dimentions.top;

                // Calculate the position of the cursor as a percentage of the total width/height of the element.
                var xpercent = Math.round(100 / (dimentions.width / x));
                var ypercent = Math.round(100 / (dimentions.height / y));

                // Update the background position of the image.
                this.style.backgroundPosition = xpercent+'% ' + ypercent+'%';
            
            }, false);


            // When leaving the container zoom out the image back to normal size.
            zoomedImage.addEventListener('mouseleave', function() {
                this.style.backgroundSize = "contain"; 
                this.style.backgroundPosition = "left center"; 
            }, false);

        }


if (document.getElementsByClassName('clean-gallery').length > 0) {
   baguetteBox.run('.clean-gallery', { animation: 'slideIn' });
}

if (document.getElementsByClassName('clean-product').length > 0) {
    window.onload = function() {
        vanillaZoom.init('#product-preview');
    };
}

    },

  beforeUnmount() {
    this.clearSeatHoldTimer()
  },

  created(){
    
   

    this.getEvent()




  },
  methods:{
      searchEvents(results, term) {
      this.search = Array.isArray(results) ? results : []
      this.searchField = term || ''
      this.main = !(this.searchField && this.search.length)
      this.err = Boolean(this.searchField && !this.search.length)
    },

      normalizePromoCodeValue(value) {
      return String(value || '').trim().toUpperCase()
    },

      normalizeStageQueryValue(value) {
      const normalized = Number.parseInt(value, 10)
      return Number.isFinite(normalized) ? normalized : null
    },

      applyStageQueryFilter(tickets) {
      const requestedStageId = this.normalizeStageQueryValue(this.$route.query.stage)
      if (!requestedStageId) {
        return tickets
      }

      const matched = tickets.filter((ticket) => Number(ticket.id) === requestedStageId)
      return matched
    },

      syncPromoRoute(codeValue, wanted = null) {
      const nextQuery = { ...this.$route.query }
      const normalizedCode = this.normalizePromoCodeValue(codeValue)
      const currentCode = this.normalizePromoCodeValue(this.$route.query.co)
      const currentWanted = this.$route.query.wanted === 'true'

      if (normalizedCode) {
        nextQuery.co = normalizedCode
      } else {
        delete nextQuery.co
      }

      if (wanted === true) {
        nextQuery.wanted = 'true'
      } else if (wanted === false) {
        delete nextQuery.wanted
      }

      const nextWanted = nextQuery.wanted === 'true'
      const routeWouldChange = currentCode !== normalizedCode || currentWanted !== nextWanted

      if (!routeWouldChange) {
        this.suppressPromoRouteWatcher = false
        return Promise.resolve()
      }

      return this.$router.replace({ name: 'event', params: { slug: this.slug }, query: nextQuery }).catch(() => {})
    },

      openPromoCode() {
      this.showCode = true
      this.errCode = false
    },

      closePromoCode() {
      this.showCode = false
      this.errCode = false
      this.promoCode = ""
      this.promoLoading = false
      this.code = null
      this.syncPromoRoute('', false)
      this.eventTickets = [...this.defaultEventTickets]
    },

      normalizeTicketsResponse(data) {
      if (Array.isArray(data)) {
        return data
      }

      if (data && Array.isArray(data.results)) {
        return data.results
      }

      return []
    },

      resolveMediaCandidates(value) {
      if (!value) {
        return []
      }

      const origin = window.location.origin
      const localBackendCandidates = ['http://127.0.0.1:8000', 'http://localhost:8000']
      const normalizePath = (candidate) => candidate
        .replace(/^\/media\//, '')
        .replace(/^.*\/media\//, '')
        .replace(/^media\//, '')
        .replace(/^\//, '')

      if (value.startsWith('data:') || value.startsWith('blob:')) {
        return [value]
      }

      if (/^https?:\/\//i.test(value)) {
        try {
          const parsed = new URL(value)

          if (!parsed.pathname.includes('/media/')) {
            return [value]
          }

          const normalizedPath = normalizePath(parsed.pathname)

          return [...new Set([
            value,
            `${origin}/media/${normalizedPath}`,
            ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
            `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
          ])]
        } catch (error) {
          return [value]
        }
      }

      const normalizedPath = normalizePath(value)

      if (value.startsWith('/media/') || value.startsWith('media/') || !value.startsWith('/')) {
        return [...new Set([
          `${origin}/media/${normalizedPath}`,
          ...localBackendCandidates.map((base) => `${base}/media/${normalizedPath}`),
          `https://gingopolisdjango.blob.core.windows.net/fomoapp/media/${normalizedPath}`,
        ])]
      }

      return [`${origin}${value}`]
    },

      classifyEventHeroAspect(width, height) {
      const numericWidth = Number(width) || 0
      const numericHeight = Number(height) || 0

      if (!numericWidth || !numericHeight) {
        return 'unknown'
      }

      const ratio = numericWidth / numericHeight

      if (isSquareBanner(numericWidth, numericHeight)) {
        return 'square'
      }

      if (Math.abs(ratio - 1) <= 0.03) {
        return 'soft-fill'
      }

      return ratio > 1 ? 'landscape' : 'portrait'
    },

      updateEventHeroAspect(event) {
      const target = event && event.target ? event.target : null
      this.eventHeroAspect = this.classifyEventHeroAspect(target && target.naturalWidth, target && target.naturalHeight)
    },

      shiftHeroImage() {
      this.eventHeroAspect = 'unknown'

      if (this.eventImageIndex < this.eventImageCandidates.length - 1) {
        this.eventImageIndex += 1
      } else {
        this.eventImageIndex = this.eventImageCandidates.length
      }
    },

      getEvent() {
      this.code = null
      this.promoCode = ''
      this.ticketRequestVersion += 1
      this.wanted = this.$route.query.wanted
      this.previewMode = ['1', 'true', 'yes', 'on'].includes(String(this.$route.query.preview || '').trim().toLowerCase())



      
      this.loadingEvent=true
      // make a GET Request to the questions list endpoint and populate the questions array


      let eventSlug = this.slug

      if (this.slug=="PSYCHO-LAB-HORROR-NIGNT"  ){
        eventSlug = 'PSYCHO-LAB-HORROR-NIGHT'
      }

      const params = new URLSearchParams()
      if (this.previewMode) {
        params.set('preview', '1')
      }
      let endpoint = `/api/events/${eventSlug}/`;
      if (params.toString()) {
        endpoint = `${endpoint}?${params.toString()}`
      }

      


      this.showLoading = true;
      apiService(endpoint, undefined, undefined, { timeoutMs: EVENT_VIEW_REQUEST_TIMEOUT_MS }).then((data) => {
        if (!data || data.err || !data.id) {
          this.event = {}
          this.category = {}
          this.venue = {}
          this.city = ''
          this.eventTickets = []
          this.defaultEventTickets = []
          this.updates = []
          this.id = null
          this.event_id = null
          this.showLoading = false
          this.loadingEvent = false
          this.err = true
          return
        }

        this.event = data;
        this.eventImageIndex = 0
        this.eventHeroAspect = 'unknown'

        //funciona solo MULALO 2 DIC 23
        if (this.event.id==90){
          window.location.href = "/event/Tambo/";
        }
        if (this.event.access!=1){
          this.showCode=true

        }
        this.id=data.id
        this.category = data.category || {}
        this.venue = data.venue || {}
        this.city = (
          (data.venue && data.venue.city && typeof data.venue.city === 'object' && data.venue.city.name) ||
          (data.city_detail && data.city_detail.name) ||
          (data.city && typeof data.city === 'object' && data.city.name) ||
          ''
        )
        this.showLoading = false;
        this.updates = data.updates
        this.event_id = data.id
        
        if(data.meta_pixel!=""){
          this.pixelId=data.meta_pixel
        }

        this.getEventTickets()

      });
      

     
    },

    
    loadMetaPixel() {
      if (this.pixelId) {
        (function(f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', this.pixelId);
        window.fbq('track', 'PageView');
      }
    },


    clearSeatHoldTimer() {
      if (this.seatHoldTimer && typeof window !== 'undefined') {
        window.clearInterval(this.seatHoldTimer)
      }
      this.seatHoldTimer = null
      this.seatHoldSecondsRemaining = 0
      this.seatHoldInitialSeconds = 0
    },

    startSeatHoldTimer() {
      this.clearSeatHoldTimer()
      if (!this.seatHoldDeadline || typeof window === 'undefined') return

      const updateCountdown = () => {
        const remaining = Math.max(0, Math.ceil((this.seatHoldDeadline - Date.now()) / 1000))
        this.seatHoldSecondsRemaining = remaining
        if (remaining <= 0) {
          this.clearSeatHoldTimer()
          this.handleSeatHoldExpiration()
        }
      }

      this.seatHoldInitialSeconds = Math.max(1, Math.ceil((this.seatHoldDeadline - Date.now()) / 1000))
      updateCountdown()
      if (this.seatHoldSecondsRemaining > 0) {
        this.seatHoldTimer = window.setInterval(updateCountdown, 1000)
      }
    },

    seatHoldSnapshot() {
      const byToken = new Map()
      this.selectedSeats.forEach((seat) => {
        const token = String(seat && seat.hold_token ? seat.hold_token : '').trim()
        if (token && !byToken.has(token)) {
          byToken.set(token, { ...seat, hold_token: token })
        }
      })
      return [...byToken.values()]
    },

    customerForHoldNotification() {
      if (!this.customer || typeof this.customer !== 'object' || !this.customer.id || !this.customer.email) {
        return null
      }
      return this.customer
    },

    async notifyExpiredSeatHolds(snapshot) {
      const customer = this.customerForHoldNotification()
      if (!customer || !snapshot.length) return false

      const customerSession = snapshot.find((seat) => seat.customer_session)?.customer_session || ''
      const payload = await apiServiceSession(
        `/api/events/${this.event.slug || this.event.id}/venue-map/holds/expired-notification/`,
        'POST',
        {
          customer: customer.id,
          hold_tokens: snapshot.map((seat) => seat.hold_token),
          customer_session: customerSession,
        },
        { timeoutMs: 15000 },
      )
      return Boolean(payload && payload.notified)
    },

    async releaseSeatHoldSnapshot(snapshot) {
      if (!snapshot.length) return
      await Promise.all(snapshot.map((seat) => (
        apiServiceSession(
          `/api/events/${this.event.slug || this.event.id}/venue-map/holds/${encodeURIComponent(seat.hold_token)}/`,
          'DELETE',
          undefined,
          { timeoutMs: 10000 },
        )
      )))
    },

    closeExpiredCheckout() {
      this.saleMode = false
      this.products = []
      this.seatsProducts = []
      this.selectedSeats = []
      this.ticketsTable = []
      this.selectedAddons = []
      this.order_fee = 0
      this.order_taxes = 0
      this.order_addons_total = 0
      this.order_base_total = 0
      this.order_total = 0
      this.order_subtotal = 0
      this.map = false
      this.mapValidator = 0
      this.mapLenght = 0
      this.step = 0
    },

    async handleSeatHoldExpiration(options = {}) {
      if (this.holdExpiryHandling) return
      const snapshot = this.seatHoldSnapshot()
      if (!snapshot.length && !options.force) return

      this.holdExpiryHandling = true
      this.holdExpiryDialogVisible = true
      this.holdExpiryEmailState = options.emailAlreadySent ? 'sent' : 'pending'
      this.clearSeatHoldTimer()
      this.closeExpiredCheckout()

      let emailSent = Boolean(options.emailAlreadySent)
      const customerAvailable = Boolean(this.customerForHoldNotification())
      try {
        if (!emailSent) {
          if (customerAvailable) {
            emailSent = await this.notifyExpiredSeatHolds(snapshot)
            this.holdExpiryEmailState = emailSent ? 'sent' : 'failed'
          } else {
            this.holdExpiryEmailState = 'unavailable'
          }
        }

        if (!emailSent && !customerAvailable) {
          try {
            await this.releaseSeatHoldSnapshot(snapshot)
          } catch (_) {
            // The server-side deadline still frees the seats; returning to the map must not be blocked.
          }
        }
      } catch (_) {
        this.holdExpiryEmailState = 'failed'
      } finally {
        this.step = this.dynamicVenueAvailable ? 7 : 0
        this.holdExpiryHandling = false
      }
    },

    handleHoldExpirationFailure(payload = {}) {
      this.handleSeatHoldExpiration({
        force: true,
        emailAlreadySent: Boolean(payload && payload.expiration_email_sent),
      })
    },

    acknowledgeHoldExpiration() {
      this.holdExpiryDialogVisible = false
    },

    focusExpiredHoldMap() {
      this.$nextTick(() => {
        const checkoutTarget = this.$refs['checkoutStart'] || this.$refs['anchor1']
        if (checkoutTarget && checkoutTarget.scrollIntoView) {
          checkoutTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    },

    startSale(){

      this.clearSeatHoldTimer()
      this.holdExpiryDialogVisible=false
      this.saleMode=true
      this.selectedSeats=[]
      this.seatsProducts=[]
      this.map=false
      this.mapValidator=0
      this.mapLenght=0
      this.step=this.isSwapEvent ? 1 : (this.dynamicVenueAvailable ? 7 : 1)
      this.$nextTick(() => {
        const checkoutTarget = this.$refs['checkoutStart'] || this.$refs['anchor1']

        if (checkoutTarget && checkoutTarget.scrollIntoView) {
          checkoutTarget.scrollIntoView({behavior: "smooth", block: "start"})
        }
      })


    },

    startNormalCheckoutFallback(){
      this.clearSeatHoldTimer()
      this.saleMode=true
      this.selectedSeats=[]
      this.seatsProducts=[]
      this.map=false
      this.mapValidator=0
      this.mapLenght=0
      this.order_taxes=0
      this.step=1
    },

    startDynamicVenueSale(payload){
      const selection = payload && typeof payload === 'object' ? payload : {}
      this.saleMode=true
      this.products=Array.isArray(selection.products) ? selection.products : []
      this.seatsProducts=Array.isArray(selection.seatsProducts) ? selection.seatsProducts : []
      this.selectedSeats=Array.isArray(selection.selectedSeats) ? selection.selectedSeats : []
      this.startSeatHoldTimer()
      this.order_total=Number.parseFloat(selection.total) || 0
      this.order_base_total=this.order_total
      this.order_fee=Number.parseFloat(selection.fee) || 0
      this.order_subtotal=Number.parseFloat(selection.subtotal) || 0
      this.order_taxes=Number.parseFloat(selection.taxes) || 0
      this.order_addons_total=0
      this.selectedAddons=[]
      this.map=false
      this.mapValidator=0
      this.mapLenght=0

      if (this.event.quick_checkout_enabled){
        const quickTickets = this.buildTicketsTableFromProducts(this.products, this.seatsProducts, this.selectedSeats)
        if (this.ticketsRequireGuestDetails(quickTickets)) {
          this.step = 2
        } else {
          this.customer=1
          this.ticketsTable=quickTickets
          this.step=this.hasEligibleFomoSafeTickets(this.ticketsTable) ? 6 : 3
        }
        return
      }

      this.step=2
    },

    focusPromoCode() {
      if (this.step !== 0) {
        return
      }

      if (!this.showPromoPanel) {
        this.openPromoCode()
      }

      this.$nextTick(() => {
        const purchasePanel = this.$refs['purchasePanel']

        if (purchasePanel && purchasePanel.scrollIntoView) {
          purchasePanel.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }

        const promoInput = this.$refs['promoInput']

        if (promoInput && promoInput.focus) {
          promoInput.focus({ preventScroll: true })
        }
      })
    },

    handleMobileAssistPrimary() {
      if (this.isSwapEvent) {
        this.startSale()
        return
      }

      if (this.eventTickets.length !== 0) {
        this.startSale()
        return
      }

      this.focusPromoCode()
    },

    focusSwapMarketplace() {
      if (this.step !== 0) {
        return
      }

      this.startSale()

      this.$nextTick(() => {
        const component = this.$refs['swapMarketplace']
        const element = component && component.$el ? component.$el : null
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      })
    },

    handleSwapQuoteHeld(cart) {
      this.swapCart = cart
    },

    getLandingVisitorToken() {
      const storageKey = 'fomo_landing_visitor_token'
      const existing = window.localStorage.getItem(storageKey)
      if (existing) {
        return existing
      }

      const nextToken = `visit-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
      window.localStorage.setItem(storageKey, nextToken)
      return nextToken
    },

    recordLandingVisit(codeValue = this.$route.query.co, source = 'landing') {
      try {
      if (!this.slug) {
        return
      }

      const normalizedCode = this.normalizePromoCodeValue(codeValue)
      const visitKey = `landing-visit:${this.slug}:${normalizedCode || 'direct'}:${new Date().toISOString().slice(0, 10)}`
      if (window.sessionStorage.getItem(visitKey)) {
        return
      }

      apiServiceSession(`/api/events/${this.slug}/landing-visit/`, 'POST', {
        visitor_token: this.getLandingVisitorToken(),
        code: normalizedCode,
        source,
        landing_path: window.location.pathname,
        referrer: document.referrer || '',
        user_agent: navigator.userAgent || '',
      }, { timeoutMs: 10000 }).then((data) => {
        if (!data || data.err) {
          return
        }

        window.sessionStorage.setItem(visitKey, '1')
      }).catch(() => {})
      } catch (_) { /* Tracking must not interrupt checkout when storage is blocked. */ }
    },

    getEventTickets() {
      if (!this.id) {
        this.eventTickets = []
        this.defaultEventTickets = []
        this.showLoading = false
        this.loadingEvent = false
        return
      }

      const requestVersion = ++this.ticketRequestVersion
      const requestedCode = this.normalizePromoCodeValue(this.$route.query.co)
      const requestedWanted = this.$route.query.wanted
      const requestedStage = this.normalizeStageQueryValue(this.$route.query.stage)

      this.promoCode = requestedCode || this.promoCode
      this.wanted = requestedWanted

      let endpoint = "/api/event-tickets/?event=" + this.id
      if (requestedCode){
        endpoint = endpoint + "&code=" + encodeURIComponent(requestedCode) + "&scope=code"
      }

      if (requestedStage) {
        endpoint = endpoint + "&stage=" + requestedStage
      }

      if (this.host){
        endpoint = endpoint + "&host=" + this.host
      }

      if (this.next) {
        endpoint = this.next;
      }

      this.loadingQuestions = true;

      apiService(endpoint, undefined, undefined, { timeoutMs: EVENT_VIEW_REQUEST_TIMEOUT_MS })
        .then(data => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          if (!data || data.err || data.detail) {
            this.errCode = true
            this.codeError = (data && (data.err || data.detail)) || 'No pudimos validar el código. Intenta de nuevo.'
            this.promoLoading = false
            this.showLoading = false
            this.loadingEvent = false
            return
          }
          this.codeError = ''
          const tickets = this.applyStageQueryFilter(this.normalizeTicketsResponse(data))

          this.code = tickets.length ? requestedCode || null : null
          this.eventTickets = tickets
          this.defaultEventTickets = requestedCode ? [] : [...tickets]
          this.errCode = Boolean(requestedCode) && tickets.length === 0
          if (!requestedCode || tickets.length) this.recordLandingVisit(requestedCode)

          if (tickets.length !== 0 && (requestedCode || requestedStage)) {
            this.showCode = false
          }

          if (requestedCode && tickets.length === 0) {
            this.showCode = true
          }

          this.showLoading = false;
          this.loadingEvent=false

          if (requestedWanted && tickets.length !== 0){
            this.startSale()
          }

          if (this.pixelId!=null){
            this.loadMetaPixel();
          }
        })
        .catch(() => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          this.eventTickets = []
          this.defaultEventTickets = []
          this.errCode = true
          this.codeError = 'No pudimos conectar para validar el código. Intenta de nuevo.'
          this.showLoading = false
          this.loadingEvent = false
        })

    },
   



    newEventTicketsSearch() {
      const requestVersion = ++this.ticketRequestVersion

      const promoCode = this.normalizePromoCodeValue(this.promoCode)
      const requestedStage = this.normalizeStageQueryValue(this.$route.query.stage)

      if (!promoCode) {
        this.errCode = true
        return
      }

      this.promoCode = promoCode
      this.codeError = ''

      let endpoint = "/api/event-tickets/?event=" + this.id + "&code=" + encodeURIComponent(promoCode) + "&scope=code"
      if (requestedStage) {
        endpoint = endpoint + "&stage=" + requestedStage
      }

      this.loadingQuestions = true;
      this.promoLoading = true
      this.errCode = false

      apiService(endpoint, undefined, undefined, { timeoutMs: EVENT_VIEW_REQUEST_TIMEOUT_MS })
        .then(data => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          if (!data || data.err || data.detail) {
            this.errCode = true
            this.codeError = (data && (data.err || data.detail)) || 'No pudimos validar el código. Intenta de nuevo.'
            this.promoLoading = false
            this.showLoading = false
            this.loadingEvent = false
            return
          }
          this.codeError = ''
          const tickets = this.applyStageQueryFilter(this.normalizeTicketsResponse(data))

          if (tickets.length === 0){
            this.errCode = true
            this.code = null
            this.showCode = true
            this.suppressPromoRouteWatcher = true
            this.syncPromoRoute('', false)
            this.eventTickets = [...this.defaultEventTickets]
          } else {
            this.errCode = false
            this.code = promoCode
            this.showCode = false
            this.suppressPromoRouteWatcher = true
            this.syncPromoRoute(promoCode, this.wanted === 'true' || this.wanted === true)
            this.eventTickets = tickets
            this.recordLandingVisit(promoCode, 'code_applied')
          }

          this.showLoading = false;
          this.promoLoading = false
        })
        .catch(() => {
          if (requestVersion !== this.ticketRequestVersion) {
            return
          }

          this.errCode = true
          this.codeError = 'No pudimos conectar para validar el código. Intenta de nuevo.'
          this.showCode = true
          this.promoLoading = false
          this.showLoading = false
        })
      
          
    },
   
    startUserCreation(products, subtotal, fee, total, map, taxes = 0){
    this.products=products
    this.order_total=Number.parseFloat(total) || 0
    this.order_base_total=Number.parseFloat(total) || 0
    this.order_fee=Number.parseFloat(fee) || 0
    this.order_subtotal=Number.parseFloat(subtotal) || 0
    this.order_taxes=Number.parseFloat(taxes) || 0
    this.order_addons_total=0
    this.selectedAddons=[]


    if (this.event.quick_checkout_enabled){
      const quickTickets = this.buildTicketsTableFromProducts(this.products)
      if (this.ticketsRequireGuestDetails(quickTickets)) {
        this.step = 2
      } else {
        this.customer=1
        this.ticketsTable=quickTickets
        this.step=this.hasEligibleFomoSafeTickets(this.ticketsTable) ? 6 : 3
      }
    }else{ //caja


      if (map>0){
      for (let index = 0; index < this.products.length; index++) {
  
      if (this.products[index].map==true && this.products[index].quantity!=0){

            this.seatsProducts.push(this.products[index])
      

      }

      this.mapLenght=this.seatsProducts.length

      this.map=true
      this.step=5

    }
    this.products = this.products.filter(product => product.map == false);// saco array

    
    }else{
      this.step++

    }

  }



  },


  startUserCreation1(selectedIds){
    this.selectedSeats= this.selectedSeats.concat(selectedIds)
    if ((this.mapValidator+1)==this.mapLenght){
    this.map=false
    this.step=2

  }
  this.mapValidator++

  
},


  startGuestNames(name, last_name, phone, email, cc){
    this.name=name
    this.last_name=last_name
    this.phone=phone
    this.email=email
    this.cc=cc
    this.step++
  },


  startFinalSale(guests, id){
    this.ticketsTable=guests.map((ticket) => ({
      ...ticket,
      access_code_snapshot: this.code || '',
    }))

    this.customer=id

    if ((Number.parseFloat(this.order_base_total) || 0) <= 0) {
      this.selectedAddons=[]
      this.order_addons_total=0
      this.order_total=this.order_base_total
      this.order_taxes=0
      this.step=3
      return
    }

    this.step=this.hasEligibleFomoSafeTickets(this.ticketsTable) ? 6 : 3
  },

  startPaymentStep(addons, addonsTotal){
    this.selectedAddons=addons
    this.order_addons_total=Number.parseFloat(addonsTotal) || 0
    this.order_total=this.order_base_total + this.order_addons_total
    this.step=3
  },

  completeSale(number, tck, receiptContext = {}){

      let  conts = []

        
       
       if (this.pixelId ) {
        
      for (let index = 0; index < this.products.length; index++) {
        let cont = {id: this.products[index].id, quantity: 1, item_price: this.products[index].amount}

        conts.push(cont)
      
      }
      
      window.fbq('track', 'Purchase', {
          value: this.subtotal,
          currency: String(this.event && this.event.presentment_currency ? this.event.presentment_currency : 'USD').toUpperCase(),
          contents: conts,
          content_type: 'product'
        });
      }
    
  
    
           
      if (number==2  ){
          const pendingQuery = { payment_type: number }
          if (receiptContext.invoiceId) pendingQuery.invoice = receiptContext.invoiceId
          if (tck && typeof tck === 'object') {
            if (tck.provider) pendingQuery.provider = tck.provider
            if (tck.invoiceId) pendingQuery.invoice = tck.invoiceId
            if (tck.attemptToken) pendingQuery.attempt = tck.attemptToken
            if (tck.paymentIntentId) pendingQuery.payment_intent = tck.paymentIntentId
            if (tck.paymentId) pendingQuery.rebill_payment = tck.paymentId
            if (tck.status) pendingQuery.status = tck.status
          }
          this.$router.push({ name: "pending-confirmation", params: { id: this.event.slug }, query: pendingQuery });
        }else{

          
          this.$router.push({ name: "confirmation", params: { id: this.event.slug}, query: { co: tck, invoice: receiptContext.invoiceId || undefined, payment_type: number } });
        }
    
  },






          


    formatDate(dateString){
         return formatEventDate(dateString, this.event, {
           day: '2-digit',
           month: '2-digit',
           year: 'numeric',
         }).replace(/\//g, '.')
    },

    hasEligibleFomoSafeTickets(tickets) {
      if (!this.event.fomo_safe_enabled || !Array.isArray(tickets)) {
        return false
      }

      return tickets.some((ticket) => (Number.parseFloat(ticket.amount) || 0) > 0)
    },

    ticketsRequireGuestDetails(tickets) {
      if (!Array.isArray(tickets)) {
        return false
      }

      return tickets.some((ticket) => Array.isArray(ticket.guest_fields) && ticket.guest_fields.length > 0)
    },

    buildTicketsTableFromProducts(products, seatsProducts = [], selectedSeats = []) {
      const expandedTickets = []
      const productRows = Array.isArray(products) ? products : []

      for (let i = 0; i < productRows.length; i += 1) {
        const product = productRows[i]
        const quantity = Number.parseInt(product.quantity, 10) || 0
        const quantityFactor = Number.parseInt(product.quantity_factor, 10) || 1

        for (let index = 0; index < quantity; index += 1) {
          for (let factor = 0; factor < quantityFactor; factor += 1) {
            expandedTickets.push({
              quantity: 1,
              amount: product.amount,
              base_amount: product.base_amount,
              tax_amount: product.tax_amount,
              tax_label: product.tax_label,
              tax_percent: product.tax_percent,
              tax_enabled: product.tax_enabled,
              tax_price_includes_tax: product.tax_price_includes_tax,
              product: product.id,
              name: product.name,
              is_courtesy: product.is_courtesy,
              first_name: '',
              last_name: '',
              payment_term: 1,
              extra_answers: {},
              guest_fields: Array.isArray(product.guest_fields) ? product.guest_fields : [],
              ig: '',
              age: '',
              cc: '',
              size: '',
              gender: 0,
              entry: '',
              seat: '',
              seat_name: '',
              seat_assigned: false,
              access_code_snapshot: this.code || '',
            })
          }
        }
      }

      const seatRows = Array.isArray(seatsProducts) ? seatsProducts : []
      const selectedSeatRows = Array.isArray(selectedSeats) ? selectedSeats : []
      let seatIndex = 0

      for (let i = 0; i < seatRows.length; i += 1) {
        const product = seatRows[i]
        const quantity = Number.parseInt(product.quantity, 10) || 0
        const quantityFactor = Number.parseInt(product.quantity_factor, 10) || 1

        for (let index = 0; index < quantity; index += 1) {
          for (let factor = 0; factor < quantityFactor; factor += 1) {
            const selectedSeat = selectedSeatRows[seatIndex] || {}
            expandedTickets.push({
              quantity: 1,
              amount: product.amount,
              base_amount: product.base_amount,
              tax_amount: product.tax_amount,
              tax_label: product.tax_label,
              tax_percent: product.tax_percent,
              tax_enabled: product.tax_enabled,
              tax_price_includes_tax: product.tax_price_includes_tax,
              product: product.id,
              name: product.name,
              is_courtesy: product.is_courtesy,
              first_name: '',
              last_name: '',
              payment_term: 1,
              extra_answers: {},
              guest_fields: Array.isArray(product.guest_fields) ? product.guest_fields : [],
              ig: '',
              age: '',
              cc: '',
              size: '',
              gender: 0,
              entry: '',
              seat: selectedSeat.id || '',
              seat_name: selectedSeat.name || '',
              seat_assigned: true,
              hold_token: selectedSeat.hold_token || '',
              access_code_snapshot: this.code || '',
            })
            seatIndex += 1
          }
        }
      }

      return expandedTickets
    },




    validateProc(){
      let format = false

      if(this.loadingEvent && !this.wanted){  

        format = false

      }else if (this.loadingEvent && this.wanted){
        format = true
      }else if (!this.loadingEvent && !this.wanted){
 
        format = true

      }else if(!this.loadingEvent && this.wanted){

        format = true
      }



         return format;
    },







  },
 

};
</script>

<style>


.vanilla-zoom {
  width: 100%;
}

.vanilla-zoom .sidebar {
  width: 100%;
  display: flex;
}

.vanilla-zoom .sidebar img.small-preview {
  width: 60px;
  margin-right: 5px;
  cursor: pointer;
  opacity: .5;
}

.vanilla-zoom .sidebar img.small-preview.active, .vanilla-zoom .sidebar img.small-preview:hover {
  opacity: 1;
}

.vanilla-zoom .sidebar img.small-preview:last-child {
  margin-right: 0;
}

.vanilla-zoom .zoomed-images {
  width: 100%;
  height: 300px;
  flex: 1;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  margin-bottom: 5px;
}


.vanilla-zoom .container-phpto {
  width: 100%;
  height: 300px;
  flex: 1;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  margin-bottom: 5px;
}

body .event-view__photo-label {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 4;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: calc(100% - 28px);
  padding: 8px 12px 8px 8px;
  border-radius: 999px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  line-height: 1;
  text-transform: uppercase;
  color: #ffffff;
  pointer-events: none;
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(26px) saturate(170%);
  -webkit-backdrop-filter: blur(26px) saturate(170%);
}

body .event-view__photo-label--checkout {
  top: 12px;
  right: 12px;
}

body .event-view__photo-label--fomo-original {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.14), rgba(226, 190, 112, 0.18));
  border-color: rgba(248, 216, 139, 0.28);
}

body .event-view__photo-label--swap {
  background: linear-gradient(135deg, rgba(109, 92, 255, 0.24), rgba(32, 216, 183, 0.18));
  border-color: rgba(111, 232, 211, 0.28);
}

body .event-view__photo-label i {
  font-size: 0.76rem;
  color: #99ffe9;
}

body .event-view__photo-label-mark,
body .event-view__gallery .event-view__photo-label-mark {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
  min-height: 18px !important;
  max-width: 18px !important;
  max-height: 18px !important;
  object-fit: contain !important;
  border-radius: 0 !important;
  position: static !important;
  z-index: auto !important;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.32)) !important;
}

.event-view__swap-copy {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: flex-start;
  color: rgba(238, 243, 255, 0.86);
}

.event-view__swap-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(120, 240, 202, 0.18), rgba(109, 168, 255, 0.16));
  border: 1px solid rgba(196, 220, 255, 0.18);
  color: #dffef4;
}

.event-view__swap-copy strong {
  display: block;
  margin-bottom: 4px;
  color: #fff;
  font-weight: 900;
}

.event-view__swap-copy p {
  margin: 0;
  color: rgba(238, 243, 255, 0.82);
  line-height: 1.5;
}

.event-view__swap-copy small.event-view__swap-trust {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: 999px;
  color: rgba(245, 238, 255, 0.9);
  background:
    radial-gradient(circle at 18% 0%, rgba(191, 146, 255, 0.26), transparent 44%),
    linear-gradient(135deg, rgba(126, 87, 255, 0.18), rgba(204, 132, 255, 0.10));
  border: 1px solid rgba(190, 154, 255, 0.26);
  box-shadow: 0 14px 34px rgba(93, 55, 190, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  font-weight: 700;
  letter-spacing: 0.01em;
  text-transform: none;
  backdrop-filter: blur(18px) saturate(150%);
  -webkit-backdrop-filter: blur(18px) saturate(150%);
}

.event-view__swap-trust i {
  color: #c8a6ff;
  text-shadow: 0 0 14px rgba(182, 131, 255, 0.62);
}

.event-view__hold-timer {
  position: sticky;
  top: 12px;
  z-index: 40;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px 14px;
  align-items: center;
  margin: 0 0 18px;
}

.event-view__hold-timer-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 15px;
  color: rgba(225, 236, 239, 0.72);
  background: rgba(255, 255, 255, 0.04);
}

.event-view__hold-timer.is-urgent .event-view__hold-timer-icon {
  color: #c8b9e6;
  background: rgba(92, 71, 130, 0.12);
  animation: hold-timer-urgent-icon 680ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

.event-view__hold-timer-copy {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 2px 14px;
  align-items: center;
}

.event-view__hold-timer-copy small,
.event-view__hold-timer-copy span {
  color: rgba(225, 236, 239, 0.72);
}

.event-view__hold-timer-copy span {
  grid-column: 1 / -1;
  font-size: 0.82rem;
}

.event-view__hold-timer-copy strong {
  grid-column: 2;
  grid-row: 1 / span 2;
  color: #ffffff;
  font-size: 1.32rem;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.08em;
}

.event-view__hold-timer-progress {
  grid-column: 1 / -1;
  height: 4px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.event-view__hold-timer-progress span {
  position: relative;
  display: block;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
  background: linear-gradient(90deg, rgba(142, 107, 196, 0.52), rgba(225, 236, 239, 0.68));
  box-shadow: 0 0 12px rgba(142, 107, 196, 0.2);
  transition: width 1s linear;
}

.event-view__hold-timer-progress span::after {
  content: '';
  position: absolute;
  inset: -8px auto -8px -35%;
  width: 36%;
  background: linear-gradient(115deg, transparent, rgba(255, 255, 255, 0.58), transparent);
  transform: translateX(-130%) rotate(14deg);
  animation: liquid-sheen-noir 3.2s ease-in-out infinite;
}

.event-view__hold-timer.is-urgent .event-view__hold-timer-progress {
  animation: hold-timer-urgent-track 760ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

.event-view__hold-expiry-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: grid;
  place-items: center;
  padding: 22px;
  background: rgba(5, 4, 8, 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  animation: hold-expiry-overlay-in 260ms ease-out both;
  will-change: opacity;
}

.event-view__hold-expiry-card {
  width: min(100%, 620px);
  transform-origin: center;
  animation: hold-expiry-card-in 600ms cubic-bezier(0.16, 1, 0.3, 1) both !important;
  will-change: opacity, transform;
}

.event-view__hold-expiry-kicker {
  position: relative;
  display: block;
  overflow: hidden;
  margin-bottom: 8px;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.event-view__hold-expiry-kicker::after {
  content: '';
  position: absolute;
  inset: -12px auto -12px -45%;
  width: 38%;
  background: linear-gradient(115deg, transparent, rgba(255, 255, 255, 0.28), transparent);
  transform: translateX(-130%) rotate(14deg);
  animation: liquid-sheen-noir 4.8s 900ms ease-in-out infinite;
  pointer-events: none;
}

.event-view__hold-expiry-card .checkout-step__intro {
  animation: hold-expiry-copy-in 480ms 20ms cubic-bezier(0.16, 1, 0.3, 1) both !important;
}

.event-view__hold-expiry-card .checkout-step__title {
  color: rgba(238, 243, 255, 0.92) !important;
  font-size: clamp(1.65rem, 7vw, 2.15rem) !important;
  line-height: 1.08;
}

.event-view__hold-expiry-warning {
  display: grid;
  gap: 6px;
  margin: 22px 0 16px;
  color: rgba(225, 236, 239, 0.78);
  animation: hold-expiry-copy-in 480ms 120ms cubic-bezier(0.16, 1, 0.3, 1) both !important;
}

.event-view__hold-expiry-warning strong {
  display: block;
  color: rgba(238, 243, 255, 0.9);
  line-height: 1.35;
}

.event-view__hold-expiry-warning span {
  display: block;
  line-height: 1.5;
}

.event-view__hold-expiry-email-state {
  min-height: 2.6em;
  margin: 0 0 12px;
  color: rgba(225, 236, 239, 0.68);
  font-size: 0.88rem;
  line-height: 1.35;
  animation: hold-expiry-copy-in 420ms 190ms cubic-bezier(0.16, 1, 0.3, 1) both !important;
}

.hold-expiry-email-enter-active,
.hold-expiry-email-leave-active {
  animation: none !important;
  transition: opacity 170ms ease, transform 210ms cubic-bezier(0.16, 1, 0.3, 1);
}

.hold-expiry-email-enter-from {
  opacity: 0;
  transform: translateY(5px);
}

.hold-expiry-email-leave-to {
  opacity: 0;
  transform: translateY(-3px);
}

.event-view__hold-expiry-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  min-height: 54px;
  padding: 0;
  font-weight: 900;
  cursor: pointer;
  animation: hold-expiry-cta-in 440ms 240ms cubic-bezier(0.16, 1, 0.3, 1) both !important;
}

.event-view__hold-expiry-action:disabled {
  cursor: wait;
  opacity: 0.72;
}

@keyframes hold-expiry-overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hold-expiry-card-in {
  from {
    opacity: 0;
    transform: translateY(28px) scale(0.955);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes hold-expiry-copy-in {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes hold-expiry-cta-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes hold-timer-urgent-icon {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(142, 107, 196, 0.26);
  }
  48% {
    transform: scale(1.075);
    box-shadow: 0 0 0 7px rgba(142, 107, 196, 0.1);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 11px rgba(142, 107, 196, 0);
  }
}

@keyframes hold-timer-urgent-track {
  0%,
  100% {
    box-shadow: 0 0 0 rgba(142, 107, 196, 0);
  }
  50% {
    box-shadow: 0 0 16px rgba(142, 107, 196, 0.2);
  }
}

.hold-expiry-leave-active {
  animation: none !important;
  transition: opacity 240ms ease;
}

.hold-expiry-leave-active .event-view__hold-expiry-card {
  animation: none !important;
  transition: opacity 190ms ease, transform 240ms cubic-bezier(0.4, 0, 1, 1);
}

.hold-expiry-leave-to {
  opacity: 0;
}

.hold-expiry-leave-to .event-view__hold-expiry-card {
  opacity: 0;
  transform: translateY(10px) scale(0.985);
}




@media (max-width: 720px) {
  .event-view__hold-timer {
    top: 8px;
    margin-bottom: 10px;
  }

  .event-view__hold-timer-copy span {
    display: none;
  }


  .event-view__hold-expiry-warning {
    gap: 8px;
    padding: 16px;
  }

  body .purchase-flow-page--venue .event-view-shell {
    padding-top: 14px !important;
    padding-bottom: 18px !important;
  }

  body .purchase-flow-page--venue .event-checkout-focus {
    gap: 6px !important;
    margin-bottom: 8px !important;
    padding: 8px 10px !important;
    border-radius: 18px !important;
  }

  body .purchase-flow-page--venue .event-checkout-focus__title {
    font-size: 1rem !important;
    line-height: 1.05 !important;
  }

  body .purchase-flow-page--venue .event-checkout-focus__micro,
  body .purchase-flow-page--venue .event-checkout-focus__rail,
  body .purchase-flow-page--venue .event-checkout-focus__text {
    display: none !important;
  }

  body .purchase-flow-page--venue .event-view__dynamic-venue-step {
    padding-top: 4px !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .event-view__hold-expiry-overlay,
  .event-view__hold-expiry-card,
  .event-view__hold-expiry-card .checkout-step__intro,
  .event-view__hold-expiry-warning,
  .event-view__hold-expiry-email-state,
  .event-view__hold-expiry-action,
  .event-view__hold-expiry-kicker::after,
  .event-view__hold-timer-progress span::after,
  .event-view__hold-timer.is-urgent .event-view__hold-timer-icon,
  .event-view__hold-timer.is-urgent .event-view__hold-timer-progress {
    animation: none !important;
  }

  .hold-expiry-leave-active,
  .hold-expiry-leave-active .event-view__hold-expiry-card,
  .hold-expiry-email-enter-active,
  .hold-expiry-email-leave-active,
  .event-view__hold-timer-progress span {
    transition: none !important;
  }
}

*, *::before, *::after {
  box-sizing: border-box;
}

.clean-block.clean-product .product-info .info .summary {
  border-top: 1px solid white;
  padding-top: 30px;
}

.clean-block.clean-product .gallery {
  padding: 16px;
  background:
    radial-gradient(circle at top left, rgba(210, 219, 236, 0.08), transparent 18%),
    radial-gradient(circle at 82% 14%, rgba(56, 64, 92, 0.22), transparent 28%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.008)),
    rgba(4, 6, 12, 0.96);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.28);
  border-radius: 28px;
  border: 1px solid rgba(198, 208, 230, 0.12);
}


 .searchcode{
       display: flex;
       flex-wrap: wrap;
       gap: 12px;
       width: 100%;
       box-shadow: none;
       }
   
       .searchcode .fa-search{

        position: absolute;
        top: 15px;
        left: 16px;

       }

       .searchcode button{
        position: static;
        height: auto;
        width: auto;
        text-align: center;
        vertical-align: middle;
       }

       
.searchcode .form-control {
  background: transparent;
  border: none;
  border-radius: 18px;
  box-shadow: none;
  outline: none;
  color: #eef3ff;
  text-indent: 0;
  height: 54px;
}


    
</style>
